var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[(!_vm.isFromPlugin)?_c('headerNav'):_vm._e(),_vm._v(" "),_c('sideBar'),_vm._v(" "),_c('contentMain',{class:_vm.isFromPlugin ? 'noPadding-top' : ''})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4331e32a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/home/home.vue
// module id = null
// module chunks = 